"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment = require("moment");

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var SelloutReleaseItemEvaluation_1 = require("./SelloutReleaseItemEvaluation");

var SelloutReleaseItemPrices_1 = require("./SelloutReleaseItemPrices");

var SelloutReleaseItemSupplyData_1 = require("./SelloutReleaseItemSupplyData");
/**
 * Represents partial snapshot of SelloutReleaseItem. Currently it is used to store state of release item
 * before reopening. It contains only fields necessary for it, but if needed it could be extended and reused.
 * This should be readonly, immutable entity.
 *
 * @author Jan Prokop
 */


var SelloutReleaseItemSnapshot =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutReleaseItemSnapshot, _DomainObject_1$Domai);

  /**
   * @param snapshotTime  Time of creation of snapshot, this could be used as identifier. When creating
   *                      snapshots of multiple items, they should share the same time. This can keep consistency
   *                      if something fails and can be used for debugging.
   * @param exported      Exported state of item.
   * @param supplyData    Supply data of item.
   * @param prices        Prices of item.
   */
  function SelloutReleaseItemSnapshot(snapshotTime, exported, supplyData, prices) {
    var _this;

    _classCallCheck(this, SelloutReleaseItemSnapshot);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemSnapshot).call(this));
    _this.snapshotTime = snapshotTime;
    _this.exported = exported;
    _this.supplyData = supplyData;
    _this.prices = prices; // These fields of SelloutReleaseItem are generally needed for impact calculation, but currently
    // we don't care about them. When needed, add them to the model and store them during reopen.

    _this.evaluation = null;
    _this.minPriceChangeInPercent = null;
    _this.maxPriceChangeInPercent = null;
    _this.minMarginChangeInPercent = null;
    return _this;
  }
  /**
   * Creates snapshot from sellout release item.
   */


  _createClass(SelloutReleaseItemSnapshot, null, [{
    key: "createFromItem",
    value: function createFromItem(item) {
      var snapshotTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : moment();
      return new SelloutReleaseItemSnapshot(snapshotTime, item.exported, item.supplyData, item.prices);
    }
    /**
     * Converter from data-dictionary representation
     */

  }, {
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutReleaseItemSnapshot(mat.snapshotTime, mat.exported, mat.supplyData, mat.prices);
    }
  }]);

  return SelloutReleaseItemSnapshot;
}(DomainObject_1.DomainObject);

exports.SelloutReleaseItemSnapshot = SelloutReleaseItemSnapshot;

SelloutReleaseItemSnapshot.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutReleaseItemSnapshot.name);
  return {
    snapshotTime: builder.date('snapshotTime', DateParser_1.DateParser.ISO_PATTERN),
    exported: builder.bool('exported'),
    supplyData: builder.opt(builder.obj('supplyData', SelloutReleaseItemSupplyData_1.SelloutReleaseItemSupplyData.schema, function (mat) {
      return SelloutReleaseItemSupplyData_1.SelloutReleaseItemSupplyData.fromDataDict(mat);
    })),
    prices: builder.obj('prices', SelloutReleaseItemPrices_1.SelloutReleaseItemPrices.schema, function (mat) {
      return SelloutReleaseItemPrices_1.SelloutReleaseItemPrices.fromDataDict(mat);
    }),
    minPriceChangeInPercent: builder.opt(builder.bigNum('minPriceChangeInPercent')),
    maxPriceChangeInPercent: builder.opt(builder.bigNum('maxPriceChangeInPercent')),
    minMarginChangeInPercent: builder.opt(builder.bigNum('minMarginChangeInPercent')),
    evaluation: builder.opt(builder.obj('evaluation', SelloutReleaseItemEvaluation_1.SelloutReleaseItemEvaluation.schema, function (mat) {
      return SelloutReleaseItemEvaluation_1.SelloutReleaseItemEvaluation.fromDataDict(mat);
    }))
  };
}();